import { render } from "./BaseSkeleton.vue?vue&type=template&id=27659408&scoped=true"
import script from "./BaseSkeleton.vue?vue&type=script&lang=js"
export * from "./BaseSkeleton.vue?vue&type=script&lang=js"

import "./BaseSkeleton.vue?vue&type=style&index=0&id=27659408&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-27659408"

export default script